import { useToggle } from "client/hooks/utils/useToggle";
import { BottomModal } from "components/common/BottomModal/BottomModal";
import { SKIP_TOUCH_ID_BOTTOM_MODAL } from "components/common/BottomModal/useBottomModal";
import { CloseIcon } from "components/common/Icons/CloseIcon";
import { SettingsIcon } from "components/common/Icons/SettingsIcon";
import { Translate } from "components/common/Translate/Translate";
import { FlipSettings } from "../../EditSettings/FlipSettings";

export const Settings = () => {
    const { isOpen, open, onClose: close } = useToggle();

    return (
        <>
            <div className="border-r border-r-irBlue-400 py-4 pr-4" onClick={open}>
                <SettingsIcon className="stroke-white" />
            </div>

            <BottomModal
                isOpen={isOpen}
                onClose={close}
                titleBar={
                    <div className="w-full flex items-center justify-between px-4 pt-2 text-black dark:text-white">
                        <div className="capitalize text-2xl whitespace-nowrap mx-auto">
                            <Translate keyName="flip-image" />
                        </div>
                        <div
                            onClick={close}
                            className="bg-irGray-300 dark:bg-darkSurface-200 h-6 w-6 rounded-full flex items-center justify-center"
                            id={SKIP_TOUCH_ID_BOTTOM_MODAL}
                        >
                            <CloseIcon />
                        </div>
                    </div>
                }
            >
                <div className="px-4 text-black dark:text-white">
                    <FlipSettings />
                </div>
            </BottomModal>
        </>
    );
};
